import React, { useContext, useRef, useState } from "react";

import { Adress } from "../../helpFunction/urlList";
import { ContextHome } from "../../contextHomeCloude/contextHome";
import { toast } from "react-toastify";
import { downloadFile, paramsQuery } from "../../helpFunction/helpFunction";

import { FormsNewFolder } from "./FormsNewFolder/FormsNewFolder";

export const MenuButtons = () => {
	const [newFolder, setNewFolder] = useState<boolean>(false);
	const [fileNameForProgress, setFileNameForProgress] = useState<string>("");

	const [progress, setProgress] = useState<string>("");

	const openInput = useRef<HTMLInputElement>(null);

	const context = useContext(ContextHome);

	if (!context) return null;
	const { setLoading, path, setPath, LongPressed, selectedFiles, clearAndReload, setFirstTach } = context;
	const buttonAnuluj = () => {
		setFirstTach(false);
		clearAndReload();
	};
	const handleBigFile = async (bigFile: any) => {
		const chunkSize = 100 * 1024 * 1024; // 100MB (adjust based on your requirements)
		const totalChunks = Math.ceil(bigFile.size / chunkSize);

		let chunkNumber = 1;
		let start = 0;
		let end = chunkSize;
		let tray = 0;
		try {
			const uploadNextChunk = async () => {
				if (chunkNumber <= totalChunks) {
					const chunk = bigFile.slice(start, end);
					const formData = new FormData();

					formData.append("bigFile", chunk);
					formData.append("chunkNumber", chunkNumber.toString());
					formData.append("totalChunks", totalChunks.toString());
					formData.append("originalname", bigFile.name);

					await fetch(`${Adress.sendBigFile}/?${paramsQuery(path, bigFile.name)}`, {
						method: "POST",
						body: formData,
						headers: { chunkNumber: chunkNumber.toString(), totalChunks: totalChunks.toString(), originalname: bigFile.name },
					})
						.then(async (data) => {
							if (data.status === 201) {
								setProgress(`${((chunkNumber / totalChunks) * 100).toFixed(1)}%`);
								chunkNumber++;
								start = end;
								end = end + chunkSize;
								await uploadNextChunk();
							} else {
								// upload ponownie
								if (tray <= 50) {
									tray++;
									await uploadNextChunk();
								} else {
									tray = 0;
								}
							}
						})
						.catch(async (error) => {
							// upload ponownie

							if (tray <= 50) {
								tray++;
								await uploadNextChunk();
							} else {
								tray = 0;
							}
						});
				}
			};
			await uploadNextChunk();
		} catch (error) {
		} finally {
			return "ok";
		}
	};

	const handleSmallFiles = async (formData: FormData) => {
		const xhr = new XMLHttpRequest();
		try {
			xhr.open("POST", `${Adress.send}/?${paramsQuery(path)}`, true);
			// xhr.setRequestHeader("options", JSON.stringify(await getFtpOptions()));
			xhr.upload.onprogress = (e) => {
				if (e.lengthComputable) {
					const percentComplete = (e.loaded / e.total) * 100;

					setProgress(percentComplete.toFixed(1) + "%");
				}
			};
			xhr.onload = () => {
				toast.success("Wysłano pomyślnie ...");
				return "ok";
			};
			xhr.send(formData);
		} catch (error) {
			toast.error(`Coś poszło nie tak UPS...`);
		} finally {
		}
	};

	const openInputSelectedFileHandler = async (selectedFiles: [{}] | any) => {
		if (selectedFiles.length >= 50) {
			alert("MAX 50 plików proszę 😀  \nl Nie przesadzać 🤣");
			return;
		}

		const formData = new FormData();

		let i = 0;

		for await (const item of selectedFiles) {
			i++;
			setFileNameForProgress(`Trwa Zapis na serwer - ${item.name} ${i}/${selectedFiles.length}`);

			if (Math.ceil(Number(item.size) / (1024 * 1024 * 100)) > 1) {
				await handleBigFile(item);
				setFileNameForProgress("");
			} else {
				formData.append("file", item);
				await handleSmallFiles(formData);
				formData.delete("file");
				setFileNameForProgress("");
			}
		}
		setTimeout(() => {
			clearAndReload();
		}, 1000);
	};
	const goBack = () => {
		setLoading(true);
		const adres = path.split("/");
		let adresSplice = adres.splice(0, adres.length - 1).join("/");
		if (adresSplice === "") adresSplice = "/";

		setPath(adresSplice);
		clearAndReload();
	};

	const removeFile = async (): Promise<void> => {
		let percentComplete = 0;
		try {
			setLoading("Czekaj ...");
			await Promise.all(
				selectedFiles.map(async (item, index) => {
					percentComplete = ((index + 1) / selectedFiles.length) * 100;
					setFileNameForProgress(` - - Usuwanie plików - - ${index}/${selectedFiles.length}`);

					setProgress(`${percentComplete.toFixed(1)}%`);

					try {
						const data = await fetch(`${Adress.removeFile}/?${paramsQuery(path, item)}`, {
							method: "DELETE",
						});
						if (data.status === 200) {
							toast.success(`Pomyślnie usunięto k ${item}`);
						} else {
							toast.error(`Błąd przy usuwaniu ${item}`);
						}
					} catch (error) {}
				}),
			);
		} catch (error) {
		} finally {
			setFileNameForProgress("");
			clearAndReload();
		}
	};

	const getFile = async () => {
		if (selectedFiles.length === 1) {
			await download(selectedFiles[0]);
		} else {
			selectedFiles.map(async (item) => {
				await download(item);
			});
		}
		clearAndReload();
	};

	const download = async (item: string) => {
		setLoading("Pobieram ...");
		try {
			if (item.indexOf(".") !== -1) {
				await fetch(`${Adress.getOne}/?${paramsQuery(path, item)}`, {
					method: "GET",
				}).then(async (res) => {
					await downloadFile(res, item);
				});
			}
		} catch (error) {
			console.log(error);
		}
		clearAndReload();
	};

	return (
		<>
			{!LongPressed && (
				<div className={"buttonsNavigation"}>
					<input title="saveFile" type="file" className="openInput" ref={openInput} onChange={(e) => openInputSelectedFileHandler(e.target.files)} multiple></input>
					<button type="button" className="button menuButton" onClick={() => openInput.current?.click()}>
						Save file
					</button>
					{path !== "/" ? (
						<button type="button" className="button menuButton" onClick={goBack}>
							Back
						</button>
					) : (
						<button type="button" className="button menuButton active_none" disabled>
							Back
						</button>
					)}
					<button className="button menuButton" onClick={() => setNewFolder(true)}>
						New folder
					</button>
					{newFolder && <FormsNewFolder setNewFolder={setNewFolder} />}
				</div>
			)}
			{LongPressed && (
				<div className={"buttonsNavigation"}>
					<button type="button" className="button menuButton" onClick={buttonAnuluj}>
						Anuluj
					</button>
					<button type="button" className="button menuButton danger" onClick={removeFile}>
						Usuń: {selectedFiles.length}
					</button>
					<button type="button" className="button menuButton" onClick={getFile}>
						Pobierz: {selectedFiles.length}
					</button>
				</div>
			)}
			{fileNameForProgress && (
				<>
					<div className="progressBarHolder">
						<p>{fileNameForProgress}</p>
						<p>{progress}</p>
						<div className="progress" style={{ width: progress }}></div>
					</div>
				</>
			)}
		</>
	);
};
